import React from 'react';
import { DateFilterContainer } from '../../shared';
import { CategoryStatisticsTable } from './CategoryStatisticsTable';

const CategoryStatistics = () => (
    <DateFilterContainer>
        <CategoryStatisticsTable />
    </DateFilterContainer>
);

export default CategoryStatistics;